export * from "./artifact.svg";
export * from "./buckler.svg";
export * from "./crystal.svg";
export * from "./kiteshield.svg";
export * from "./orb.svg";
export * from "./trinket.svg";

export const z = 8;
